import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { BottoneIcona } from './base.tsx'
import { IconaBusta, IconaChiudi } from './Icone.tsx'

/**
 * Riga dell'email di recupero sopra la pagina (decisioni di Davide dell'1/11/2026, 520): ai dipendenti
 * che non hanno un'email personale di recupero verificata. Porta a «Il mio profilo», non blocca niente,
 * si chiude con la crocetta e torna all'accesso dopo, come la riga del secondo fattore
 * (AvvisoSecondoFattore.tsx), di cui usa lo stile.
 */
export function AvvisoEmailRecupero() {
  const { io } = useSessione()
  const { pathname } = useLocation()
  const [chiuso, setChiuso] = useState(false)
  if (!io?.emailRecupero?.daImpostare || chiuso || pathname === '/profilo') return null
  return (
    <div className="fattore-avviso invito" role="status">
      <IconaBusta />
      <p>
        <strong>Aggiungi la tua email personale di recupero</strong>: se dimentichi la password, il collegamento per
        sceglierne una nuova arriva lì. <Link to="/profilo">Aggiungila</Link>
      </p>
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi l’avviso dell’email di recupero"
                    onClick={() => setChiuso(true)} />
    </div>
  )
}
